import React, { useState } from 'react';
import * as Bixby from '$/core';
import './PortfolioDropDown.scss';
import { connect } from 'react-redux';
import { AppState } from '$/store';
import { getHasPublicCompaniesFeatureFlagState } from '$/store/login/selectors';
import {
  getIsCurrentUserAdminState,
  getIsCurrentUserCreditSightsAnalystState,
  getIsCurrentUserCreditSightsOpsState,
  getIsCurrentUserRatingsAnalystState,
  getIsCurrentUserSuFAnalystState,
} from '$/store/profile/selectors';

interface IPortfolioDropDownProps {
  gridView: string;
  hasPublicCompaniesFeatureFlag: boolean;
  isAdmin: boolean;
  isCreditSightsOpsSufOrRatings: boolean;
  onSetGridView: (selectedOption: string) => void;
}

const PortfolioDropDown: React.FC<IPortfolioDropDownProps> = props => {
  const { gridView, onSetGridView, hasPublicCompaniesFeatureFlag, isAdmin, isCreditSightsOpsSufOrRatings } = props;
  const [showOptions, setShowOptions] = useState(false);

  const toggleOptions = () => setShowOptions(!showOptions);

  const handleClick = (selectedOption: string) => {
    onSetGridView(selectedOption);
    setShowOptions(false);
  };
  const analyticsActions = [Bixby.Constants.PORTFOLIO_VIEW_ALL];

  if (!isAdmin && !isCreditSightsOpsSufOrRatings) {
    analyticsActions.push(Bixby.Constants.PORTFOLIO_VIEW_MINE);
  }

  if (hasPublicCompaniesFeatureFlag) {
    analyticsActions.push(Bixby.Constants.PORTFOLIO_VIEW_PRIVATE);
    analyticsActions.push(Bixby.Constants.PORTFOLIO_VIEW_PUBLIC);
    analyticsActions.push(Bixby.Constants.PORTFOLIO_VIEW_PUBLIC_EXCLUDE_DEFUNCT);
  }

  analyticsActions.push(Bixby.Constants.PORTFOLIO_VIEW_SYNDICATION);

  return (
    <React.Fragment>
      <div onClick={toggleOptions} className="portfolio_dropdown">
        {gridView}
      </div>
      {showOptions && (
        <div className="portfolio_dropdown_options_menu">
          {analyticsActions.map(action => {
            return (
              <div className="portfolio_dropdown_option" key={action} onClick={() => handleClick(action)}>
                {action}
              </div>
            );
          })}
        </div>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state: AppState) => {
  const { hasPublicCompaniesFeatureFlag } = getHasPublicCompaniesFeatureFlagState(state);
  const { isAdmin } = getIsCurrentUserAdminState(state);
  const { isCreditSightsAnalyst } = getIsCurrentUserCreditSightsAnalystState(state);
  const { isSuFAnalyst } = getIsCurrentUserSuFAnalystState(state);
  const { isCreditSightsOps } = getIsCurrentUserCreditSightsOpsState(state);
  const { isRatingsAnalyst } = getIsCurrentUserRatingsAnalystState(state);

  return {
    hasPublicCompaniesFeatureFlag,
    isAdmin,
    isCreditSightsOpsSufOrRatings: isCreditSightsAnalyst || isCreditSightsOps || isSuFAnalyst || isRatingsAnalyst,
  };
};

export default connect(mapStateToProps)(PortfolioDropDown);
